var $8f6a480bb40b134f$exports = {};
"use strict";
// document.addEventListener("click", function (e) {
//   if (e.target.closest("body") !== null) {
//     hide_videos();
//   }
// });
///////////////////////////////////////
// insert tab component
const $8f6a480bb40b134f$var$header = document.querySelector(".header");
const $8f6a480bb40b134f$var$calculatorSection = document.getElementById("section--1");
const $8f6a480bb40b134f$var$toggleCalculatorSection = function() {
    const isOpen = $8f6a480bb40b134f$var$calculatorSection.classList.toggle("section--calculator--open");
    $8f6a480bb40b134f$var$calculatorSection.setAttribute("aria-expanded", String(isOpen));
};
$8f6a480bb40b134f$var$calculatorSection.addEventListener("click", function(e) {
    if (e.target.closest(".calculator__container")) return;
    $8f6a480bb40b134f$var$toggleCalculatorSection();
});
$8f6a480bb40b134f$var$calculatorSection.addEventListener("keydown", function(e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    $8f6a480bb40b134f$var$toggleCalculatorSection();
});
const $8f6a480bb40b134f$var$message = document.createElement("div"); // Created, but not inserted
// message.classList.add("cookie-message");
// message.innerHTML =
//   'We use cookies for better content <button class="btn btn--close--cookie">Got it!</button>';
// header.before(message);
$8f6a480bb40b134f$var$header.append($8f6a480bb40b134f$var$message);
///////////////////////////////////////
// Button scrolling
const $8f6a480bb40b134f$var$btnScrollTo = document.querySelector(".btn--scroll-to");
const $8f6a480bb40b134f$var$section0 = document.querySelector("#section--0");
$8f6a480bb40b134f$var$btnScrollTo.addEventListener("click", function() {
    $8f6a480bb40b134f$var$section0.scrollIntoView({
        behavior: "smooth"
    });
});
document.querySelectorAll(".nav__link").forEach(function(el) {
    el.addEventListener("click", function(e) {
        e.preventDefault();
    });
});
document.querySelector(".nav__links").addEventListener("click", function(e) {
    if (e.target.classList.contains("nav__link") && !e.target.classList.contains("btn")) {
        const id = e.target.getAttribute("href");
        document.querySelector(id).scrollIntoView({
            behavior: "smooth"
        });
    }
});
const $8f6a480bb40b134f$var$h1 = document.querySelector("h1");
const [...$8f6a480bb40b134f$var$children_arr] = $8f6a480bb40b134f$var$h1.parentElement.children;
$8f6a480bb40b134f$var$children_arr.forEach(function(el) {
    if (el !== $8f6a480bb40b134f$var$h1) el.style.transform = "scale(1)";
});
///////////////////////////////////////////////////////////////////////////
const $8f6a480bb40b134f$var$nav = document.querySelector(".nav");
const $8f6a480bb40b134f$var$handleEvent = function(e) {
    if (e.target.classList.contains("nav__link")) {
        const link = e.target;
        const siblings = link.closest(".nav").querySelectorAll(".nav__link");
        siblings.forEach((el)=>{
            if (el !== link) el.style.opacity = this.opacity;
        });
    }
};
$8f6a480bb40b134f$var$nav.addEventListener("mouseover", $8f6a480bb40b134f$var$handleEvent.bind({
    opacity: 0.5
}));
$8f6a480bb40b134f$var$nav.addEventListener("mouseout", $8f6a480bb40b134f$var$handleEvent.bind({
    opacity: 1
}));
/////////////////////////////////////////////////////////////////////////sticky navigation
const $8f6a480bb40b134f$var$navHeight = $8f6a480bb40b134f$var$nav.getBoundingClientRect().height + 1;
const $8f6a480bb40b134f$var$stickyNav = function(entries) {
    const [entry] = entries;
    if (!entry.isIntersecting) $8f6a480bb40b134f$var$nav.classList.add("sticky");
    else $8f6a480bb40b134f$var$nav.classList.remove("sticky");
};
const $8f6a480bb40b134f$var$headerObserver = new IntersectionObserver($8f6a480bb40b134f$var$stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: `-${$8f6a480bb40b134f$var$navHeight}px`
});
$8f6a480bb40b134f$var$headerObserver.observe($8f6a480bb40b134f$var$header);
////////////////////////////////////////////////// Reveal section elements
// const targetSections = document.querySelectorAll(".section");
// const revealSection = function (entries) {
//   const [entry] = entries;
//   if (!entry.isIntersecting) return;
//   entry.target.classList.remove("section--hidden");
// };
// const obsSection = new IntersectionObserver(revealSection, {
//   root: null,
//   threshold: 0.2,
// });
// targetSections.forEach(function (section) {
//   const width = window.innerWidth;
//   if (width > 1024) {
//     section.classList.add("section--hidden"); // Apply desktop layout styles
//   } else {
//     const operations_section = operations.parentElement;
//     operations_section.classList.add("section--hidden");
//   }
//   obsSection.observe(section);
// });
////////////////////////////////////////////////// Lazy Load Images
const $8f6a480bb40b134f$var$allTheSections = document.querySelectorAll("img[data-src]");
const $8f6a480bb40b134f$var$revealImg = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    // Remove blur after high-quality is loaded
    entry.target.classList.remove("lazy-img");
    // Swap lazy image for high-quality
    entry.target.classList.remove("section--hidden");
    observer.unobserve(entry.target);
};
const $8f6a480bb40b134f$var$sectionObserver = new IntersectionObserver($8f6a480bb40b134f$var$revealImg, {
    root: null,
    threshold: 0.1,
    rootMargin: "0px"
});
$8f6a480bb40b134f$var$allTheSections.forEach(function(section) {
    $8f6a480bb40b134f$var$sectionObserver.observe(section);
});
////////////////////////////////////////////////// Build a slider
// const slides = function () {
//   const slides = document.querySelectorAll(".slide");
//   const sliderBtnRt = document.querySelector(".slider__btn--right");
//   const sliderBtnLt = document.querySelector(".slider__btn--left");
//   let curSlide = 0;
//   const maxSlide = slides.length - 1;
//   const goToSlide = function (curSlide) {
//     slides.forEach(function (s, i) {
//       s.style.transform = `translateX(${(i - curSlide) * 100}%)`;
//     });
//   };
//   const nextSlide = function () {
//     if (curSlide === maxSlide) {
//       curSlide = 0;
//     } else {
//       curSlide++;
//     }
//     goToSlide(curSlide);
//     createDots();
//     activateDot(curSlide);
//   };
//   const prevSlide = function () {
//     if (curSlide === 0) {
//       curSlide = maxSlide;
//     } else {
//       curSlide--;
//     }
//     goToSlide(curSlide);
//     createDots();
//     activateDot(curSlide);
//   };
//   // Dynamic State
//   sliderBtnRt.addEventListener("click", function () {
//     nextSlide();
//   });
//   document.addEventListener("keydown", function (e) {
//     if (e.key === "ArrowRight") {
//       nextSlide();
//     }
//     if (e.key == "ArrowLeft") {
//       prevSlide();
//     }
//   });
//   sliderBtnLt.addEventListener("click", function () {
//     prevSlide();
//   });
//   // add dots
//   const dotsContainer = document.querySelector(".dots");
//   const createDots = function () {
//     dotsContainer.innerHTML = "";
//     slides.forEach(function (_, i) {
//       dotsContainer.insertAdjacentHTML(
//         "beforeend",
//         `<button class="dots__dot" data-slide=${i}></button>`
//       );
//     });
//   };
//   const activateDot = function (slide) {
//     document
//       .querySelectorAll(".dots")
//       .forEach((dot) => dot.classList.remove("dots__dot--active")); // Clear active class
//     document
//       .querySelector(`.dots__dot[data-slide="${slide}"]`)
//       .classList.add("dots__dot--active"); // Add active class
//   };
//   // Initial state
//   const init = function () {
//     goToSlide(0);
//     createDots();
//     activateDot(0);
//   };
//   init();
//   dotsContainer.addEventListener("click", function (e) {
//     if (e.target.classList.contains("dots__dot")) {
//       const { slide } = e.target.dataset;
//       curSlide = parseInt(slide);
//       goToSlide(curSlide);
//       createDots();
//       activateDot(curSlide);
//     }
//   });
// };
// slides();
////////////////////////////////////////////////// Dynamic layout
function $8f6a480bb40b134f$var$adjustLayout() {
    const width = window.innerWidth;
    if (width <= 480) ;
    else width;
}
window.addEventListener("resize", $8f6a480bb40b134f$var$adjustLayout);
$8f6a480bb40b134f$var$adjustLayout();


//# sourceMappingURL=index.84754363.js.map
